module.exports = __webpack_public_path__ + "img/linked-in-icon.b9d72bfe.svg";